import { CONTAINER_SPECS } from '@freight-cbm/shared-logic';
import { PALLET_SPECS } from '@freight-cbm/shared-logic';
import { FormulaReference } from '@/components/Reference/FormulaReference';
import { GlossarySection } from '@/components/Reference/GlossarySection';
import { MeasurementGuide } from '@/components/Reference/MeasurementGuide';

interface ReferenceScreenProps {
  onErrorReport?: () => void;
}

export function ReferenceScreen(_props: ReferenceScreenProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-6)' }}>
      <h2 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 'var(--font-weight-bold)' }}>
        Reference
      </h2>

      {/* Container Specs Table */}
      <div className="section-divider">
        <h3 className="section-title">Standard Container Specifications</h3>
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                {['Type', 'Internal (L×W×H)', 'Volume (CBM)', 'Max Payload (kg)'].map((h) => (
                  <th key={h}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {CONTAINER_SPECS.map((spec) => (
                <tr key={spec.type}>
                  <td className="cell-emphasis">{spec.type}</td>
                  <td>{spec.internalLength}×{spec.internalWidth}×{spec.internalHeight} m</td>
                  <td>{spec.volumeCBM}</td>
                  <td>{spec.maxPayloadKg.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pallet Specs Table */}
      <div className="section-divider">
        <h3 className="section-title">Standard Pallet Specifications</h3>
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                {['Type', 'L×W (m)', 'Max Stack Height (m)', 'Max Weight (kg)'].map((h) => (
                  <th key={h}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {PALLET_SPECS.map((spec) => (
                <tr key={spec.type}>
                  <td className="cell-emphasis">{spec.type}</td>
                  <td>{spec.length}×{spec.width}</td>
                  <td>{spec.maxStackHeight}</td>
                  <td>{spec.maxWeightKg.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* DIM Divisor Reference */}
      <div className="section-divider">
        <h3 className="section-title">Common DIM Divisors</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--space-2)' }}>
          {[
            { mode: 'Air Freight', divisor: 6000, note: 'IATA standard (cm³/kg)' },
            { mode: 'Ocean LCL', divisor: 1000, note: '1 CBM = 1000 kg' },
            { mode: 'Courier (DHL/FedEx/UPS)', divisor: 5000, note: 'International express' },
            { mode: 'Courier (US Domestic)', divisor: 139, note: 'in³/lb' },
          ].map((row) => (
            <div key={row.mode} style={{ padding: 'var(--space-2)', background: 'var(--color-bg-secondary)', borderRadius: 'var(--radius-md)' }}>
              <div style={{ fontWeight: 'var(--font-weight-medium)' }}>{row.mode}</div>
              <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)' }}>Divisor: {row.divisor}</div>
              <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)' }}>{row.note}</div>
            </div>
          ))}
        </div>
      </div>

      <FormulaReference />
      <MeasurementGuide />
      <GlossarySection />
    </div>
  );
}
